/**
 * MaintenanceBanner Component - Phase 68 M5 Task 5.4
 *
 * Warning banner shown to super_admin users when maintenance mode is active.
 * Indicates that regular users cannot access the platform.
 *
 * Design reference: tasks.md § 5.4 MaintenanceBanner Component
 */
import React from 'react'
import { Alert, AlertTitle } from '@mui/material'

/**
 * Maintenance mode warning banner for super admins.
 *
 * - MUI Alert with warning severity and filled variant
 * - Not dismissible (always visible while maintenance active)
 * - Positioned above all other content
 */
const MaintenanceBanner: React.FC = () => {
  return (
    <Alert
      severity="warning"
      variant="filled"
      sx={{
        borderRadius: 0,
        // Ensure banner spans full width and sits at top
        position: 'sticky',
        top: 0,
        zIndex: 1300, // Above app bar
      }}
    >
      <AlertTitle sx={{ fontWeight: 600, mb: 0 }}>
        Modo de mantenimiento activo
      </AlertTitle>
      Los usuarios no pueden acceder a la plataforma.
    </Alert>
  )
}

export default MaintenanceBanner
